

































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ImportFileComponent from '@/components/ImportFileComponent.vue';

@Component({
	components: {
		ImportFileComponent,
	},
})
export default class Import extends Vue {
	public dialog = true;

	private closeDialog() {
		this.dialog = false;
		location.href = '/';
	}
}
